export default "__VITE_ASSET__3e0ba23d__"